import { connect } from 'react-redux';
import GDPRConsernPopup from './gdpr_consern_popup';
import {
  gdprSwitcherValueChanged,
  shouldShowGDPRConsent,
  authSocial,
  clearError
} from '../../../actions/auth';

const mapStateToProps = ({
  auth: {
    consentedToGDPR, GDPRConsernPopupVisible, socialParams
  },
  user: { user, analyticProps }
}) => ({
  consentedToGDPR,
  GDPRConsernPopupVisible,
  socialParams,
  tcpBanner: user?.tcPpBanner,
  termsAndPoliciesUpdateViewed: analyticProps?.termsAndPoliciesUpdateViewed
});

export default connect(
  mapStateToProps,
  {
    gdprSwitcherValueChanged,
    shouldShowGDPRConsent,
    authSocial,
    clearError
  }
)(GDPRConsernPopup);
